import React from "react";

export default function FlashIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='31'
      height='43'
      viewBox='0 0 31 43'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.95152 20.1588L15.948 2.19302C17.0426 0.787941 19.0944 1.66248 19.0944 3.53414V17.4399C19.0944 18.561 19.899 19.47 20.8916 19.47H27.6992C29.2458 19.47 30.0702 21.5298 29.0484 22.8412L15.052 40.807C13.9574 42.212 11.9056 41.3376 11.9056 39.4658V25.5602C11.9056 24.439 11.101 23.53 10.1084 23.53H3.3007C1.75422 23.53 0.92988 21.4702 1.95152 20.1588Z'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
